import { defineStore } from 'pinia';
import { SallaMarketplace } from '@/v2/modules/products/entities/marketplaces/salla';
import { useProductEditorStore } from '@/v2/modules/products/stores/product-editor/index';
import { marketplacesEnum } from '@/v2/utils/marketplaces';

export const useSallaStore = defineStore('salla', {
	state: () => ({
		data: {},
		variants: {},
	}),
	getters: {
		formValues(state) {
			const productEditorStore = useProductEditorStore();

			const formValues = {};

			productEditorStore.sallaLinkedMarketplaces.forEach((m) => {
				const linkedVariants = {};

				productEditorStore.data.variants.forEach((variant) => {
					const linkedVariant = this.data[m.id]?.linked_variants.find(
						(el) => el.id === variant.id,
					);

					if (!linkedVariant) return;

					linkedVariants[variant.id] = {
						title_ar: this.data[m.id]?.title_ar,
						description_ar: this.data[m.id]?.description_ar,
						...linkedVariant,
						extra_data: {
							linker_categories: this.data[m.id]?.linker_categories?.map((c) => c.id) || [],
                            promotion: {
								title: this.data[m.id]?.promotion?.title || null,
								sub_title: this.data[m.id]?.promotion?.subtitle || null
							}
						},
					};
				});

				formValues[m.id] = {
					new_product_images:
						this.data[m.id]?.linked_variant_images
							.filter((el) => el.new)
							.map((el) => ({
								product_image_id: el.id,
								image_url: el.image,
								linked_marketplace_id: m.id,
								marketplace_id: marketplacesEnum.Salla,
							})) || [],
					linked_product: {},
					linked_variant: linkedVariants,
				};
			});

			return formValues;
		},
	},
	actions: {
		async getCategoryAttributes(categoryID) {
			this.loadingAttr = true;
			try {
				const data = await SallaMarketplace.getCategoryAttributes(categoryID);
				this.data.attributes = data?.data ?? [];
				this.initAttributesValues();
			} finally {
				this.loadingAttr = false;
			}
		},
		async setData(marketplacesData) {
			const productEditorStore = useProductEditorStore();

			marketplacesData.forEach((salla) => {
				const linkedProduct = salla?.linked_product;
				const linkedVariants = salla?.linked_variant;
				const variants = Object.values(linkedVariants).map((el) => el[0]);

				let title_ar = '';
				let description_ar = '';

				title_ar =
					variants[0]?.translations.find((item) => item.locale == 'ar')?.title ||
					productEditorStore.data.title_ar;
				description_ar =
					variants[0]?.translations.find((item) => item.locale == 'ar')?.description ||
					productEditorStore.data.short_description_ar;

				const data = {
					title_ar,
					description_ar,
					linked_variant_images: (linkedProduct?.linked_product_images || []).map((image) => ({
						...image,
						image: image.path,
					})),
					linker_categories: variants[0]?.extra_data?.linker_categories_object || [],
                    promotion: {
						title: variants[0]?.extra_data?.promotion?.title || null,
						subtitle: variants[0]?.extra_data?.promotion?.sub_title || null
					},
					linked_variants: variants.map((variant) => {
						const productVariant = productEditorStore.data.variants.find(
							(el) => el.id === variant.variant_id,
						);

						return {
							id: variant.variant_id,
							sku: variant.sku,
							barcode: variant.barcode || productVariant?.barcode,
						};
					}),
				};

				this.variants[salla.linked_marketplace_id] = variants;
				this.data[salla.linked_marketplace_id] = data;
			});
		},
		async submit() {},
	},
});
